import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useIsMobile } from '../hooks/useIsMobile';
import { slugify } from '../utils/slugify';

const H_PAD = 'clamp(40px, 5.5vw, 80px)';

export default function Cart() {
  const { items, removeItem, updateQty, total } = useCart();
  const isMobile = useIsMobile();
  const pad = isMobile ? '40px 20px' : `clamp(40px, 4vw, 60px) ${H_PAD}`;

  if (items.length === 0) return (
    <main style={{ padding: isMobile ? '60px 20px' : `120px ${H_PAD}`, textAlign: 'center' }}>
      <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '24px', marginBottom: '24px' }}>Votre panier est vide.</p>
      <Link to="/catalogue" style={{ fontFamily: "'Josefin Sans', sans-serif", fontSize: '11px', letterSpacing: '3px', textTransform: 'uppercase', color: '#111', textDecoration: 'none', borderBottom: '1px solid #111', paddingBottom: '2px' }}>
        Continuer vos achats
      </Link>
    </main>
  );

  return (
    <main style={{ padding: pad, minHeight: '70vh' }}>
      <h1 style={{ fontFamily: "'Josefin Sans', sans-serif", fontSize: '12px', letterSpacing: '4px', textTransform: 'uppercase', marginBottom: '48px', fontWeight: 300 }}>
        Votre Panier
      </h1>

      <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 360px', gap: isMobile ? '40px' : '60px' }}>
        {/* Items */}
        <div>
          {items.map(item => (
            <div key={`${item.id}-${item.size}`} style={{
              display: 'grid', gridTemplateColumns: isMobile ? '80px 1fr' : '100px 1fr',
              gap: '20px', marginBottom: '28px', paddingBottom: '28px', borderBottom: '1px solid #eee',
            }}>
              <Link to={`/produit/${slugify(item.name)}`}>
                <img src={item.images?.[0] || 'https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=300&q=80'} alt={item.name} style={{ width: '100%', aspectRatio: '1', objectFit: 'cover', display: 'block' }} />
              </Link>
              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <div>
                  <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: isMobile ? '16px' : '18px', marginBottom: '6px' }}>{item.name}</div>
                  {item.size && <div style={{ fontFamily: "'Josefin Sans', sans-serif", fontSize: '10px', letterSpacing: '2px', textTransform: 'uppercase', color: '#888', marginBottom: '4px' }}>Taille {item.size}</div>}
                  <div style={{ fontFamily: "'Josefin Sans', sans-serif", fontSize: '12px', color: '#555', letterSpacing: '1px' }}>Dh {Number(item.price).toFixed(2)} MAD</div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '12px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', border: '1px solid #ddd' }}>
                    <button onClick={() => updateQty(item.id, item.qty - 1, item.size)} style={{ width: '36px', height: '36px', background: 'none', border: 'none', cursor: 'pointer', fontSize: '16px' }}>−</button>
                    <span style={{ width: '36px', textAlign: 'center', fontFamily: "'Josefin Sans', sans-serif", fontSize: '12px' }}>{item.qty}</span>
                    <button onClick={() => updateQty(item.id, item.qty + 1, item.size)} style={{ width: '36px', height: '36px', background: 'none', border: 'none', cursor: 'pointer', fontSize: '16px' }}>+</button>
                  </div>
                  <button onClick={() => removeItem(item.id, item.size)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontFamily: "'Josefin Sans', sans-serif", fontSize: '10px', letterSpacing: '1px', color: '#888', textTransform: 'uppercase' }}>
                    Supprimer
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Summary */}
        <div>
          <div style={{ border: '1px solid #eee', padding: isMobile ? '24px' : '32px' }}>
            <h2 style={{ fontFamily: "'Josefin Sans', sans-serif", fontSize: '11px', letterSpacing: '3px', textTransform: 'uppercase', marginBottom: '24px', fontWeight: 300 }}>Récapitulatif</h2>
            {items.map(item => (
              <div key={`${item.id}-${item.size}`} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
                <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '15px' }}>{item.name}{item.size ? ` T.${item.size}` : ''} × {item.qty}</span>
                <span style={{ fontFamily: "'Josefin Sans', sans-serif", fontSize: '12px', color: '#555' }}>Dh {(item.price * item.qty).toFixed(2)}</span>
              </div>
            ))}
            <div style={{ borderTop: '1px solid #eee', paddingTop: '20px', marginTop: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontFamily: "'Josefin Sans', sans-serif", fontSize: '11px', letterSpacing: '2px', textTransform: 'uppercase' }}>Total</span>
              <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '22px', fontWeight: 500 }}>Dh {total.toFixed(2)} MAD</span>
            </div>
            <Link to="/commande" style={{
              display: 'block', textAlign: 'center', marginTop: '24px',
              padding: '16px', background: '#111', color: '#fff', textDecoration: 'none',
              fontFamily: "'Josefin Sans', sans-serif", fontSize: '11px', letterSpacing: '3px', textTransform: 'uppercase',
              transition: 'opacity 0.2s',
            }}
              onMouseEnter={e => e.target.style.opacity = '0.85'}
              onMouseLeave={e => e.target.style.opacity = '1'}
            >
              Passer la commande
            </Link>
          </div>
        </div>
      </div>
    </main>
  );
}
